import { axios, handleError } from '../axios';

export const seriesOverview = () => {
  return new Promise((resolve) => {
    axios
      .get('admin/series/overview/', {})
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
